<template>
  <a-modal :title="title"
           :visible="showTubeView"
           :width="1000"
           destroyOnClose
           @ok="handleOk"
           @cancel="closeTubeView">
    <a-modal title="地图"
             style="top: 20px"
             :width="800"
             v-model="mapVisible"
             @ok="mapVisible = false"
             @cancel="mapVisible = false">
      <lonlat-map ref="lonlatMaps"
                  @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model class="log-form"
                  :model="addOrUpdateForm"
                  ref="addOrUpdateForm"
                  :rules="rules"
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 14 }">
      <!-- 巡检维修-任务管理-新增 -->
      <a-row class="form-row"
             type="flex"
             justify="center"
             :gutter="4">
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="任务编号">
            <span v-if="!addOrUpdateForm.taskNumber">(系统自动生成)</span>
            <span v-else>{{ addOrUpdateForm.taskNumber }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24"></a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="任务名称"
                             prop="taskName">
            <a-input placeholder="请输入"
                     v-model="addOrUpdateForm.taskName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="片区">
            <a-tree-select :tree-data="zoneTreeData"
                           v-model="addOrUpdateForm.zoneId"
                           :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                           placeholder="请选择片区"
                           allow-clear
                           tree-default-expand-all></a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="负责人"
                             prop="principal">
            <a-select show-search
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      v-model="addOrUpdateForm.principal"
                      @change="handleChange">
              <a-select-option v-for="item in userlist"
                               :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="任务类型"
                             prop="taskType">
            <a-select placeholder="请选择任务类型"
                      v-model="addOrUpdateForm.taskType">
              <a-select-option v-for="item in TaskList"
                               :key="item.dictValue">{{ item.dictValue }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="计划开始时间："
                             prop="predictStim">
            <a-date-picker style="width: 100%"
                           format="YYYY-MM-DD"
                           v-model="addOrUpdateForm.predictStim"
                           placeholder="请选择计划开始时间"
                           @change="onChanges"
                           :disabled-date="disabledDate"
                           :disabled-time="disabledDateTime" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="计划处理时长："
                             prop="planTime">
            <a-input placeholder="请输入时长（单位：人天）"
                     v-model="addOrUpdateForm.planTime" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :md="12" :sm="24">
          <a-form-model-item label="开始时间" prop="startTime">
            <a-date-picker v-model="addOrUpdateForm.startTime" show-time placeholder="开始时间" @change="onChange" />
          </a-form-model-item>
        </a-col> -->
        <a-col :md="12"
               :sm="24">
          <a-form-model-item label="协办人">
            <a-button @click="addSponsor"
                      style="margin-right: 20px">添加</a-button>
            <a-tag v-for="item in assistPersonsList"
                   :key="item.key"
                   closable
                   @close="delSponsor(item.key)">{{
              item.title
            }}</a-tag>
          </a-form-model-item>
          <!-- <a-form-model-item label="协办人" props="assistPersons">
            <a-button @click="addSponsor" style="margin-right: 20px">添加</a-button>
            <span v-if="showPersons">
              <a-tag v-for="(item, index) in assistPersonsList" :key="index" closable @close="delSponsor(item.key)">
                <span v-if="showPersons">{{ item.title }}</span>
                <span v-else>{{ item }}</span>
              </a-tag>
            </span>
          </a-form-model-item> -->
        </a-col>
        <a-col :md="12"
               :sm="24"></a-col>
        <a-col :md="24"
               :sm="24">
          <a-form-model-item label="位置"
                             prop="place"
                             :label-col="{ span: 3 }"
                             :wrapper-col="{ span: 20 }">
            <a-button type="primary"
                      @click="addAddress">位置</a-button>
            <a-input placeholder="请输入"
                     v-model="addOrUpdateForm.place" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12"
               :sm="24"></a-col>
        <a-col :md="24"
               :sm="24">
          <a-form-model-item label="地址"
                             :label-col="{ span: 3 }"
                             :wrapper-col="{ span: 20 }"
                             prop="address">
            <a-textarea placeholder="请输入"
                        v-model="addOrUpdateForm.address"
                        :rows="2" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24"
               :sm="24">
          <a-form-model-item label="任务描述"
                             :label-col="{ span: 3 }"
                             :wrapper-col="{ span: 20 }"
                             prop="description">
            <a-textarea placeholder="多行输入"
                        v-model="addOrUpdateForm.description"
                        :rows="4" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal ref="addModal"
              @addPepople="addPepople"></addModal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
import { start } from 'nprogress'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
  },
  props: {},
  data () {
    return {
      dayjs,
      mapVisible: false,
      title: '新增',
      showPersons: false,
      queryOneUrl: '/pipe-network/inspection_tasks/',
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        place: '',
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        taskNumber: '',
        status: '',
        predictEtime: '',
        predictStime: '',
        predictStim: '',
        taskName: '',
        planTime: '',
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      TaskList: [],
      assistPersonsList: [],
      userlist: [],
      currentId: '',
    }
  },
  computed: {
    rules () {
      return {
        taskName: [{ required: true, message: '请选择任务名称', trigger: 'change' }],
        taskType: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
        zoneId: [{ required: true, message: '请选择片区', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        assistPersons: [{ required: true, message: '请选择协办人', trigger: 'change' }],
        predictStim: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        planTime: [
          { required: true, message: '请选择计划处理时长', trigger: 'change' },
          // /^(?:[1-9]\d?|[1234]\d{2}|500)$/
          { pattern: /^([1-9]\d*)(\.\d{1,6})?$|^0\.\d{1,6}?$/, message: '请输入大于零的人天数', trigger: 'change' },
        ],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        description: [{ required: true, message: '请输入任务描述', trigger: 'change' }],
      }
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
  },
  created () {
    this.getZoneData()
    this.getTaskList()
    this.getUserList()
  },
  methods: {
    disabledDate (current) {
      return current && current < dayjs().startOf('day')
    },
    disabledDateTime () { },
    addAddress () {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        console.log(JSON.stringify(this.addOrUpdateForm.place))
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(this.currentUser.tenant.point)
        })
      }
    },
    handleMapOk (data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
    },
    moment,
    handleChange (value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    delSponsor (key) {
      let i = this.assistPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      let j = this.addOrUpdateForm.assistPersons.indexOf(key)
      this.addOrUpdateForm.assistPersons.splice(j, 1)
    },
    addPepople (list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map((item) => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    addSponsor () {
      this.$refs.addModal.edit(this.addOrUpdateForm.assistPersons)
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    getTaskList () {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.TaskList = data
      })
    },
    handleOk (e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            sysType: '巡检',
            ...this.addOrUpdateForm,
          })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                this.addOrUpdateForm.zoneId = ''
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    getZoneData () {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    onChange (value, dateString) {
      this.addOrUpdateForm.startTime = dateString
    },
    onChanges (value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
      this.addOrUpdateForm.predictStim = dateString
    },
    onChanget (value, dateString) {
      this.addOrUpdateForm.predictEtime = dateString
    },
    _updateForm (real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit (i) {
      this.showTubeView = true
      let msgaddress = ''
      let geojson = ''
      if (i) {
        msgaddress = i.msgAddress
        geojson = JSON.parse(i.geoJson).coordinates.toString()
      }
      this.addOrUpdateForm = {
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: msgaddress,
        assistPersons: [],
        principal: '',
        taskNumber: '',
        status: '',
        predictEtime: '',
        predictStime: '',
        predictStim: '',
        taskName: '',
        planTime: '',
        place: geojson,
      }
    },
    getPeopleList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        // 
        let list = []
        data.map((item) => {
          list.push({
            title: item.realName,
            key: item.id,
          })
        })
        // console.log(JSON.stringify(list));
        if (this.addOrUpdateForm.assistPersons.length > 0) {
          this.assistPersonsList = []
          this.addOrUpdateForm.assistPersons.map((item) => {
            this.assistPersonsList.push(
              list.find((listItem) => {
                return listItem.key == item
              })
            )
          })
          if (
            (this.assistPersonsList.length > 0) &
            (this.assistPersonsList.key !== undefined) &
            (this.assistPersonsList.title !== undefined)
          ) {
            this.showPersons = true
            console.log(JSON.stringify(this.assistPersonsList))
          } else {
            if (this.assistPersonsList[0] == undefined || this.assistPersonsList[0].title == undefined) {
              this.showPersons = false
            } else {
              this.showPersons = true
            }
            console.log(this.assistPersonsList)
          }
          // console.log(this.assistPersonsList, '1234')
        }
      })
    },
    closeTubeView () {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      console.log(this.addOrUpdateForm)
      this.assistPersonsList = []
      this.addOrUpdateForm.zoneId = ''
      // this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped></style>
